import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const ProfileInfo = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-profile-info', 'flex w-full flex-wrap gap-8', className)}
    {...props}
  />
));
ProfileInfo.displayName = 'ProfileInfo';

const ProfileSidebar = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-profile-sidebar', 'shrink-0', className)}
    {...props}
  />
));
ProfileSidebar.displayName = 'ProfileSidebar';

const ProfileForm = React.forwardRef(({ className, ...props }, ref) => (
  <form
    ref={ref}
    className={cn('c-profile-form', 'w-56 max-w-full grow', className)}
    {...props}
  />
));
ProfileForm.displayName = 'ProfileForm';

export { ProfileInfo, ProfileSidebar, ProfileForm };
